import { Link, useLocation } from 'react-router-dom';

const NotFoundPage = () => {
  const { pathname } = useLocation();

  return (
    <main className="min-h-screen flex items-center justify-center px-5 py-12 text-cyan-100">
      <section className="w-full max-w-2xl overflow-hidden rounded-xl border border-cyan-400/30 bg-slate-950/90 shadow-[0_0_60px_rgba(34,211,238,0.12)]">
        <div className="flex items-center gap-2 border-b border-cyan-400/20 px-5 py-3">
          <span className="h-3 w-3 rounded-full bg-rose-400" />
          <span className="h-3 w-3 rounded-full bg-amber-300" />
          <span className="h-3 w-3 rounded-full bg-emerald-400" />
          <span className="ml-2 text-xs text-slate-400">zsh — route-not-found</span>
        </div>

        <div className="space-y-6 p-6 sm:p-10">
          <p className="text-sm text-emerald-300">
            guest@zamanShahed:~$ locate <span className="break-all text-cyan-200">{pathname}</span>
          </p>

          <div>
            <p className="text-6xl font-bold tracking-tight text-cyan-300 sm:text-8xl">404</p>
            <h1 className="mt-3 text-xl font-semibold text-white sm:text-2xl">
              Route not found
            </h1>
            <p className="mt-2 text-sm leading-6 text-slate-400">
              The requested page isn&apos;t in this build. It may have been moved,
              deleted, or never existed.
            </p>
          </div>

          <div className="rounded-lg border border-slate-700 bg-black/40 p-4 font-mono text-sm">
            <p className="text-rose-300">error: ENOENT — no route at that address</p>
            <p className="mt-2 text-slate-500">
              hint: try the home directory instead
            </p>
          </div>

          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md border border-cyan-300/50 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-300/10 focus:outline-none focus:ring-2 focus:ring-cyan-300"
          >
            <span aria-hidden="true">&lt;_</span>
            cd ~
          </Link>
        </div>
      </section>
    </main>
  );
};

export default NotFoundPage;
